module.exports = __webpack_public_path__ + "img/img_05@2x.13dc62cf.png";